// Components
import FeaturedListingCollection from './FeaturedListingCollection';

// Misc / utils
import { emitTrackImpressionForPropertyCardEvent } from 'app/shared/models/Clickstream/ListingCardClickstreamEvents';
import type { ListingDetails } from '@/srcLegacy/types/listingDetails.type';
import type { ListingType } from '@/srcLegacy/types';
import type { SimilarListingDetails } from '@/srcLegacy/types/similarListingDetails.type';
import type { HotpadsListing } from '@/srcLegacy/client/analytics/types';

interface PortfolioPropertiesV2Props {
  portfolioListings: Array<ListingDetails>;
  onListingClick: () => void;
  screenWidthForDesktopSRPFilter?: 'sm' | 'md' | 'lg' | 'xl';
}

const PortfolioProperties = ({
  portfolioListings = [],
  onListingClick,
  screenWidthForDesktopSRPFilter,
}: PortfolioPropertiesV2Props) => {
  if (portfolioListings.length < 1) {
    return null;
  }

  const trackImpression = (listing: ListingType | SimilarListingDetails) => {
    emitTrackImpressionForPropertyCardEvent({
      listing: listing as HotpadsListing,
      triggerLocation: 'portfolio_listings_module',
    });
  };

  return (
    <FeaturedListingCollection
      header="More from this provider"
      listings={portfolioListings}
      onListingClick={onListingClick}
      screenWidthForDesktopSRPFilter={screenWidthForDesktopSRPFilter}
      trackImpression={trackImpression}
      triggerLocation={'home_details'}
      triggerObject={'home_details_component|more_from_provider'}
    />
  );
};

export default PortfolioProperties;
